enum ShopOrderMode {
  Table = 1,
  NoTable = 2,
  Salon = 3
}

export default ShopOrderMode
